import { jsx as _jsx } from "react/jsx-runtime";
import { Fab as MuiFab } from '@mui/material';
export function Fab(props) {
    return _jsx(MuiFab, { ...props });
}
